<template>
  <div>
    <encuestado-form
      :is-add-new-user-sidebar-active.sync="isAddNewSidebarActive"
      :form-type="formType"
      :data-edit="dataEdit"
      :data-reniec="dataReniec"
      @refetch-data="refetchData"
      @error-data="showError"
      @search-dni="searchDni"
    />
    <!-- Table Container Card -->
    <b-card
      no-body
      class="mb-0"
    >

      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Mostrando</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="pageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>registros</label>
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="query"
                class="d-inline-block mr-1"
                placeholder="Buscar..."
              />
              <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                v-b-tooltip.hover.top="titleFormatoEncuestado"
                target="_blank"
                :href="`${publicPath}FORMATOS/IMPORTARBENEFICIARIOS.xlsx`"
                variant="outline-primary"
                class="btn-icon"
                style="margin-right: 5px"
              >
                <feather-icon icon="DownloadIcon" />
              </b-button>
              <label
                v-b-tooltip.hover.top="titleFormatoImportar"
                for="file"
                class="btn btn-outline-success"
                style="margin-right:5px;margin-top:4px"
              >
                <span
                  v-show="isBusyImport===true"
                >
                  Cargando...
                </span>
                <span
                  v-show="isBusyImport===false"
                >
                  Importar
                </span>
              </label>
              <input
                v-show="false"
                id="file"
                type="file"
                @change="onChange"
              >
              <b-button
                variant="primary"
                @click="openForm('new')"
              >
                <span class="text-nowrap">Nuevo</span>
              </b-button>
            </div>
          </b-col>
        </b-row>

      </div>

      <b-table
        ref="refUserListTable"
        class="position-relative"
        :items="items"
        responsive
        :fields="fields"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="No se encontraron registros"
        :busy="isBusy"
      >
        <template #table-busy>
          <div class="text-center text-primary my-2">
            <b-spinner
              variant="primary"
              class="align-middle"
            />
            <strong class="ml-1">Cargando...</strong>
          </div>
        </template>
        <template #cell(foto)="data">
          <b-media vertical-align="center">
            <template #aside>
              <b-avatar
                size="32"
                :src="`data:image/jpeg;base64,${data.item.encuestado.foto}`"
              />
            </template>
            <b-link
              class="font-weight-bold d-block text-nowrap"
            >
              {{ data.item.encuestado.nombre }} {{ data.item.encuestado.apellidoPaterno }} {{ data.item.encuestado.apellidoMaterno }}
            </b-link>
            <small class="text-muted">Tipo Persona: {{ data.item.encuestado.tipoPersona }}. {{ data.item.encuestado.tipoDocumento }}: {{ data.item.encuestado.documento }}</small>
          </b-media>
        </template>
        <template #cell(estado)="data">
          <b-badge
            v-if="data.item.encuestado.estado == true"
            pill
            variant="light-success"
            class="text-capitalize"
          >
            Activo
          </b-badge>

          <b-badge
            v-if="data.item.encuestado.estado == false"
            pill
            variant="light-danger"
            class="text-capitalize"
          >
            Inactivo
          </b-badge>
        </template>

        <!-- Column: Actions -->
        <template #cell(acciones)="data">
          <b-dropdown
            variant="link"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >

            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>
            <b-dropdown-item @click="getEdit(data)">
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">Editar</span>
            </b-dropdown-item>
            <b-dropdown-item @click="validateDni(data)">
              <feather-icon icon="CheckIcon" />
              <span class="align-middle ml-50">Validar DNI</span>
            </b-dropdown-item>
            <b-dropdown-item @click="getDelete(data)">
              <feather-icon icon="TrashIcon" />
              <span class="align-middle ml-50">Eliminar</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>

      </b-table>
      <div class="mx-2 mb-2">
        <b-row>

          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Mostrando {{ from }} a {{ to }} de {{ of }} registros</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >

            <b-pagination
              v-model="page"
              :total-rows="totalItems"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import Vue from 'vue'
import {
  BCard, BRow, BCol, BFormInput, BTable, BBadge, BDropdown, BDropdownItem, BPagination, BSpinner, BButton, BAvatar, BMedia, BLink, VBTooltip,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { _ } from 'vue-underscore'
import vSelect from 'vue-select'
import XLSX from 'xlsx'
import store from '@/store'
import moment from 'moment'
import { showToast } from '@/helpers'
import EncuestadoForm from './EncuestadoForm.vue'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BTable,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BSpinner,
    EncuestadoForm,
    vSelect,
    BButton,
    BAvatar,
    BMedia,
    BLink,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  data: () => ({
    isBusy: false,
    isAddNewSidebarActive: false,
    isOpenEditPassword: false,
    dataEdit: {},
    dataReniec: {},
    formType: '',
    isBusyImport: false,
    page: 1,
    perPage: 10,
    totalRows: 0,
    totalItems: 0,
    publicPath: process.env.BASE_URL,
    totalPage: 0,
    from: 0,
    to: 0,
    of: 0,
    dataImport: [],
    pageOptions: [10, 20, 50],
    sortBy: null,
    sortDesc: false,
    sortDirection: 'asc',
    titleFormatoEncuestado: 'Formato para subir datos de encuestado',
    titleFormatoImportar: 'Importar encuestados en formato Excel',
    query: '',
    items: [],
    fields: [
      { key: 'encuestado.idEncuestado', sortable: true, thClass: 'd-none', tdClass: 'd-none' },
      { key: 'foto', label: 'Encuestado', thStyle: { width: '12px' } },
      { key: 'encuestado.telefono', label: 'Teléfono', sortable: true },
      { key: 'encuestado.estadoCivil', label: 'estadoCivil' },
      { key: 'encuestado.sexo', label: 'sexo', sortable: true },
      { key: 'acciones' },
    ],
  }),
  watch: {
    perPage: {
      handler() {
        this.listarRegistros()
      },
    },
    page: {
      handler() {
        this.listarRegistros()
      },
    },
    query: {
      handler() {
        this.listarRegistros()
      },
    },
  },
  mounted() {
    this.listarRegistros()
  },
  methods: {
    saveData(data) {
      if (_.isUndefined(data[0])) {
        this.showToast('Ha ocurrido un error', 'El formato seleccionado es invalido.', 'danger')
        this.isBusyImport = false
      } else {
        store
          .dispatch('gsencuesta/ENCUESTADO_CREATE_ALL', data)
          .then(response => {
            this.isBusyImport = false
            // const data = (response.length <= 0) ? 'Datos guardados correctamente' : `los siguientes documentos ya existe: ${}`
            let documents = ''
            let mensaje = ''
            if (response.length > 0) {
              response.forEach(dat => {
                documents = `${documents} ${dat.dni} - `
              })
              mensaje = `Los siguientes documentos ya existen: ${documents}`
            } else {
              mensaje = 'Datos guardados correctamente'
            }
            this.showToast('Operación Exitosa', mensaje, 'success')
            this.listarRegistros()
            return response
          })
          .catch(error => {
            this.isBusyImport = false
            this.showToast('Ha ocurrido un error', error.response.data.errorMessage, 'danger')
            // this.listarRegistros()
          })
      }
    },
    onChange(event) {
      Vue.swal({
        title: 'Está seguro?',
        text: 'Nombre y apellidos serán actualizados',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Guardar',
        cancelButtonText: 'Cancelar',
        customClass: {
          confirmButton: 'btn btn-danger',
          cancelButton: 'btn btn-primary ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.saveBeneficiarios(event)
        }
      })
    },
    saveBeneficiarios(event) {
      this.isBusyImport = true
      const file = event.target.files ? event.target.files[0] : null
      if (file) {
        let stateTabData = false
        const fileReader = new FileReader()
        fileReader.onload = e => {
          let binary = ''
          const bytes = new Uint8Array(e.target.result)
          const length = bytes.byteLength
          for (let i = 0; i < length; i += 1) {
            binary += String.fromCharCode(bytes[i])
          }
          const workbook = XLSX.read(binary, { type: 'binary', cellDates: true, dateNF: 'dd/mm/yyyy;@' })
          const sheetNameList = workbook.SheetNames
          this.dataImport = []
          sheetNameList.forEach(y => {
            const roa = XLSX.utils.sheet_to_json(workbook.Sheets[y])
            if (roa.length > 0) {
              if (y === 'DATA') {
                this.dataImport = []
                stateTabData = true
                roa.forEach(dat => {
                  this.dataImport.push({
                    nombre: dat.NOMBRE,
                    apellidoPaterno: dat.APELLIDO_PATERNO,
                    apellidoMaterno: dat.APELLIDO_MATERNO,
                    documento: dat.DOCUMENTO,
                    sexo: dat.SEXO,
                    estadoCivil: dat.ESTADO_CIVIL,
                    direccion: dat.DIRECCION,
                    telefono: dat.TELEFONO,
                    emil: _.isUndefined(dat.EMAIL) ? '' : dat.EMAIL,
                    tipoPersona: dat.TIPO_PERSONA,
                    tipoDocumento: dat.TIPO_DOCUMENTO,
                    representanteLegal: dat.REPRESENTANTE_LEGAL,
                    idUbigeo: dat.UBIGEO,
                    // observacion: dat.TECNICO_DNI, // solución temporal, luego pasar por put
                  })
                })
              }
            }
          })
          document.getElementById('file').value = ''
          if (!stateTabData) {
            this.isBusyImport = false
            this.showToast('Warning', 'En el formato excel, el tap de exportación debe ser de nombre DATA.', 'warning')
          } else {
            this.saveData(this.dataImport)
          }
        }
        fileReader.readAsArrayBuffer(file)
      }
    },
    listarRegistros() {
      this.isBusy = true
      store
        .dispatch('gsencuesta/ENCUESTADO_FIND_ALL', {
          limit: this.perPage,
          query: this.query,
          page: this.page,
          sortBy: 'idDetalleEncuestadoFicha%7CDESC', // idEncuestado
        })
        .then(response => {
          this.items = response.items
          this.totalRows = response.totalRows
          this.totalItems = response.totalItems
          this.totalPage = response.totalPage
          this.from = this.perPage * (this.page - 1) + (this.totalRows ? 1 : 0)
          this.to = this.perPage * (this.page - 1) + this.totalRows
          this.of = this.totalItems
          this.isBusy = false
        })
        .catch(error => {
          this.showError(error)
          this.isBusy = false
        })
    },
    openForm(type) {
      this.formType = type
      this.isAddNewSidebarActive = true
    },
    getEdit(data) {
      this.formType = 'edit'
      this.isAddNewSidebarActive = true
      this.dataEdit = data.item.encuestado
    },
    validateDni(data) {
      this.$swal({
        title: '¿Está seguro de validar este DNI?',
        text: 'Datos referentes al DNI serán actualizados',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí',
        cancelButtonText: 'No',
        customClass: {
          confirmButton: 'btn btn-danger',
          cancelButton: 'btn btn-primary ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          store
            .dispatch('gsencuesta/ENCUESTADO_UPDATE_WITH_VALIDATION_DNI', {
              documento: data.item.encuestado.documento,
            })
            .then(response => {
              this.listarRegistros()
              this.$bvToast.toast('Ha Actualizado correctamente el registro.', {
                title: 'Operación Exitosa',
                variant: 'success',
                solid: true,
              })
              return response
            })
            .catch(error => {
              this.$bvToast.toast(error.response.data.errorMessage, {
                title: 'Ha ocurrido un error',
                variant: 'danger',
                solid: true,
              })
            })
        }
      })
    },
    getDelete(data) {
      this.$swal({
        title: '¿Está seguro de eliminar este registro?',
        text: 'Va eliminar un registro!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí',
        cancelButtonText: 'No',
        customClass: {
          confirmButton: 'btn btn-danger',
          cancelButton: 'btn btn-primary ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          store
            .dispatch('gsencuesta/ENCUESTADO_DELETE', {
              id: data.item.idEncuestado,
            })
            .then(response => {
              this.listarRegistros()
              this.$bvToast.toast('Ha Eliminado correctamente el registro.', {
                title: 'Operación Exitosa',
                variant: 'success',
                solid: true,
              })
              return response
            })
            .catch(error => {
              this.$bvToast.toast(error.response.data.errorMessage, {
                title: 'Ha ocurrido un error',
                variant: 'danger',
                solid: true,
              })
            })
        }
      })
    },
    refetchData(response) {
      let message = 'El proceso se ha ejecutado satisfactoriamente.'
      if (response.message) {
        message = response.message
      }
      this.$bvToast.toast(message, {
        title: 'Operación Extitosa',
        variant: 'success',
        solid: true,
      })
      this.listarRegistros()
    },
    showError(error) {
      let errorMessage = 'Intentelo en otro momento.'
      if (error.response) {
        errorMessage = error.response.data.errorMessage
      }
      this.$bvToast.toast(errorMessage, {
        title: 'Ha ocurrido un error',
        variant: 'danger',
        solid: true,
      })
    },
    searchDni(dni) {
      this.$swal({
        width: 370,
        text: 'Cargando....',
        showCancelButton: false,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        onOpen: () => {
          this.$swal.showLoading()
          store
            .dispatch('gsencuesta/ENCUESTADO_FIND_ALL_RENIEC', {
              dni,
            })
            .then(res => {
              this.dataReniec = res.datosPersona === undefined ? [] : res.datosPersona
              /* this.formData.nombre = this.data_reniec.prenombres
              this.formData.apellidoPaterno = this.data_reniec.apPrimer
              this.formData.apellidoMaterno = this.data_reniec.apSegundo */
              this.$swal.close()
            })
            .catch(error => {
              this.$swal.close()
              this.$bvToast.toast(error.message, {
                title: 'Ha ocurrido un error',
                variant: 'danger',
                solid: true,
              })
            })
        },
      }).then(() => {
        // console.log(result)
      })
    },
    getDateFmt(date) {
      return moment(String(date)).format('DD/MM/YYYY hh:mm a')
    },
    showToast,
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
